import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';
/**
 * 둘다 검색 API 이나 사용 용도가 좀 다른듯
 * SCHAPI -> 라이브, vod, 게시글, 스트리머 검색 용도
 * SCKETCAPI -> 프로필, 바로가기, 금칙어, 연관검색어, 연관 스트리머 (주된 내용 외의 것들을 다루는 API)
 */
export const SchApi = ApiCore(globalDomains.SCH_AFREECATV);

export const ScketcApi = ApiCore(globalDomains.SCKETC_AFREECATV);